const getSchoolInfo = (state) => {
  return {
    scod: state.school_dt.scod,
    schENG: state.school_dt.schENG,
    schKH: state.school_dt.schKH,
    proENG: state.school_dt.proENG,
    proKH: state.school_dt.proKH,
    disENG: state.school_dt.disENG,
    disKH: state.school_dt.disKH,
    comENG: state.school_dt.comENG,
    comKH: state.school_dt.comKH,
    fid: state.school_dt.fid,
    type_code: state.school_dt.type_code,
    principal_name_kh: state.school_dt.principal_name_kh,
    pho_num: state.school_dt.pho_num
  }
}
const getGrade = (state) => {
  return {
    g7: state.school_dt.g7,
    g8: state.school_dt.g8,
    g9: state.school_dt.g9,
    g10: state.school_dt.g10,
    g11: state.school_dt.g11,
    g12: state.school_dt.g12
  }
}
const getScore = (state) => {
  return {
    sco_g7: state.school_dt.sco_g7,
    sco_g8: state.school_dt.sco_g8,
    sco_g9: state.school_dt.sco_g9,
    sco_g10: state.school_dt.sco_g10,
    sco_g11: state.school_dt.sco_g11,
    sco_g18: state.school_dt.sco_g18,
    sco_g12: state.school_dt.sco_g12,
    sco_g19: state.school_dt.sco_g19
  }
}
export {
  getSchoolInfo,
  getGrade,
  getScore
}
